import React from "react";
import classNames from "classnames";
import { ReactSVG } from "react-svg";
import { Icon_Facility } from "@/types/qr";
import { getFacilityPreviewIconPath } from "@/components/IconList/previewsIconPath";
import { injectThemeableIcon } from "@/components/IconList/injectThemeableIcon";
import { resolveInitialFacilities } from "../../utils/resolveInitialFacilities";
import "./InitPreviewFacilities.scss";

export interface InitPreviewFacilitiesProps {
  /** Facilities explícitas para el estado inicial de la preview */
  previewFacilities?: Icon_Facility[];
  /** Clase CSS adicional */
  className?: string;
}

/**
 * Componente para mostrar iconos de facilities de placeholder en estado inicial.
 */
export function InitPreviewFacilities({
  previewFacilities,
  className,
}: InitPreviewFacilitiesProps) {
  const resolvedFacilities = React.useMemo(
    () => resolveInitialFacilities(previewFacilities),
    [previewFacilities]
  );

  if (!resolvedFacilities || resolvedFacilities.length === 0) {
    return null;
  }

  const containerClasses = classNames(
    "init-preview-facilities",
    "init-preview-facilities__icons",
    className
  );

  return (
    <div className={containerClasses}>
      {resolvedFacilities.map((facility: Icon_Facility, index: number) => (
        <span
          key={`${facility}-${index}`}
          className="init-preview-facilities__item"
          aria-label={`facility-${facility}`}
        >
          <ReactSVG
            className="init-preview-facilities__svg"
            src={getFacilityPreviewIconPath(facility)}
            role="img"
            aria-label={`facility-${facility}`}
            beforeInjection={injectThemeableIcon}
          />
        </span>
      ))}
    </div>
  );
}
